import {
  deleteProvider,
  getCityDetails,
  getProviders,
  lookupProviders,
  updateProviderAddress,
} from '../../../../service/providers'
import { isEmpty, isUndefined } from 'lodash'

import AddedDoctor from './AddedDoctor.component'
import BouncingDotsLoader from '../../../common/Loading/BouncingDotsLoader'
import { County } from '../../../../interface/CountyInterface'
import { GiHeartPlus } from 'react-icons/gi'
import { MdEdit, MdDeleteOutline } from 'react-icons/md'
import Icon from '../../../common/Icon/Icon.component'
import DeleteConfirmationModal from '../../../common/Modal/DeleteConfirmationModal'
import ModalComponent from '../../../common/Modal/Modal.component'
import NearCities from './NearCities.component'
import ProviderCardComponent from './ProviderCard.component'
import QuotesRefreshProvider from '../../../../context/QuotesRefreshContext'
import React from 'react'
import SearchPrompt from './SearchPrompt.component'
import { SnackbarTypes } from '../../../../enums/SnackbarTypesEnum'
import StringConstants from '../../../../constants/StringConstants'
import Tooltip from '../../../common/Tooltip/Tooltip.component'
import customerStore from '../../../../datastore/CustomerStore'
import { getApiErrorMessage } from '../../../../utils/StringUtils'
import mPartDPlansFilterStore from '../../../../datastore/medicareQuotes/MPartPlanFilterQuotesStore'
import medicareAdvantageFilterQuoteStore from '../../../../datastore/medicareQuotes/MedicareAdvantageFilterQuoteStore'
import snackbarStore from '../../../../datastore/SnackbarStore'
import styled from '@emotion/styled'
import theme from '../../../../global/theme'
import { updateCheckpoint } from '../../../../service/customer'
import { useLocation } from 'react-router-dom'
import userActionStore from '../../../../datastore/UserActionStore'
import { withRouter } from '../../../common/WithRouter/WithRouter.component'

interface AddDoctorProps {
  handleNext?: () => void
  isSpouse?: boolean
  isInfoSteps?: boolean
}

const Container = styled.div`
  padding: 20px 0px;
`
const AddedDoctorsWrapper = styled.div``

const SearchPromptWrapper = styled.div`
  background: ${theme.colors.white};
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.07);
  border: 1px solid ${theme.colors.borderColor};
  padding: 20px 24px;
  margin-bottom: 20px;
  h3 {
    color: ${theme.colors.primary};
    font-size: 17px;
    font-weight: 700;
    margin-bottom: 6px;
  }
  > p {
    font-size: 13px;
    color: ${theme.colors.textGrey};
    line-height: 1.55;
    margin-bottom: 4px;
  }
`
const AddedDoctorsHeader = styled.div`
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: ${theme.colors.textGrey};
  padding: 16px 0px 6px;
  border-top: 1px solid ${theme.colors.borderColor};
`
const Address = styled.div`
  padding: 14px 0 4px;
  h3 {
    font-size: 13px;
    font-weight: 600;
    color: ${theme.colors.textDark};
    padding-bottom: 8px;
  }
  p {
    color: ${theme.colors.textDark};
    font-size: 13px;
  }
`
const TableWrapper = styled.div`
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid ${theme.colors.borderColor};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  margin-top: 4px;
`
const EntryTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
`
const Th = styled.th`
  text-align: left;
  padding: 10px 14px;
  font-size: 11px;
  font-weight: 600;
  color: ${theme.colors.textGrey};
  border-bottom: 1px solid ${theme.colors.borderColor};
  background: ${theme.colors.backgroundColorContainer};
  text-transform: uppercase;
  letter-spacing: 0.4px;
`
const Td = styled.td`
  padding: 11px 14px;
  border-bottom: 1px solid ${theme.colors.borderColor};
  vertical-align: middle;
  color: ${theme.colors.textDark};
  font-size: 13px;
`
const ActionsTd = styled.td`
  padding: 11px 14px;
  border-bottom: 1px solid ${theme.colors.borderColor};
  vertical-align: middle;
  white-space: nowrap;
  width: 1%;
`
const IconBtn = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 5px;
  border-radius: 6px;
  color: ${theme.colors.textGrey};
  line-height: 0;
  transition: color 0.15s, background 0.15s;
  &:hover { color: ${theme.colors.primary}; background: ${theme.colors.backgroundColorContainer}; }
`
const DeleteIconBtn = styled(IconBtn)`
  margin-left: 2px;
  &:hover { color: #e53935; background: #fdecea; }
`

const AddDoctor: React.FC<AddDoctorProps> = ({
  handleNext,
  isSpouse,
  isInfoSteps,
}) => {
  const [addDoctorState, setAddDoctorState] = React.useState<{
    AddedDoctor: any[]
    Doctor: any[]
    addingDoctors: boolean
  }>({
    AddedDoctor: [],
    Doctor: [],
    addingDoctors: false,
  })

  const [zipcodeInfo, setZipcodeInfo] = React.useState<{
    code: string
    county?: County
    state?: string
    optCounties?: County[]
  }>({
    code: customerStore.pharmacyPostalCode || customerStore.postalCode,
    county: userActionStore.zipCodeCache.find(
      (iterator) => iterator.code === customerStore.pharmacyPostalCode
    )?.county || {
      countyName: customerStore.county,
      countyFips: '',
    },
    state:
      userActionStore.zipCodeCache.find(
        (iterator) => iterator.code === customerStore.pharmacyPostalCode
      )?.state || customerStore.state,
    optCounties: [],
  })

  const [cityDetails, setCityDetails] = React.useState<any>()
  const [loadingFetch, setLoadingFetch] = React.useState<boolean>()
  const [providersLookUpData, setProvidersLookUpData] = React.useState<any>()
  const [selectedCity, setSelectedCity] = React.useState<any>({})
  const [forSpouse, setForSpouse] = React.useState(
    isUndefined(isSpouse) ? customerStore.forSpouse : isSpouse
  )
  const [showProvidersSearchBar, setShowProvidersSearchBar] =
    React.useState<boolean>(false)
  const [isEditProvider, setIsEditProvider] = React.useState<boolean>(false)
  const [popUpModal, setpopUpModal] = React.useState<boolean>(false)
  const [pendingDeleteDoctor, setPendingDeleteDoctor] =
    React.useState<any>(null)
  const [editProviderLoading, setEditProviderLoading] =
    React.useState<boolean>(false)
  const [searchDoctor, setSearchDoctor] = React.useState(false)
  const [addProviderLoading, setAddProviderLoading] =
    React.useState<boolean>(false)
  const [deleteProviderLoading, setDeleteProviderLoading] =
    React.useState<boolean>(false)
  const [loadingCityDetails, setLoadingCityDetails] =
    React.useState<boolean>(false)
  const location = useLocation()

  React.useEffect(() => {
    updateCheckpoint({ path: location.pathname, action: 'USER_DROP_OFF' })
  }, [])

  React.useEffect(() => {
    setForSpouse(isUndefined(isSpouse) ? customerStore.forSpouse : isSpouse)
  }, [isSpouse])

  React.useEffect(() => {
    fetchCityDetails()
    fetchAllProviders()
  }, [forSpouse])

  const fetchLookUpProviders = (doctorPrefix: string) => {
    setLoadingFetch(true)
    lookupProviders({
      $name: doctorPrefix,
      type: 'cloudsearch',
      city: selectedCity.city,
      state: selectedCity.state,
      lat: selectedCity.latitude,
      lng: selectedCity.longitude,
    })
      .then((response: any) => {
        const data = response.data.data.map(
          (x: { id: string; name: string }) => {
            return { title: x.name, id: x.id }
          }
        )
        setProvidersLookUpData(data)
      })
      .finally(() => {
        setLoadingFetch(false)
      })
  }

  const fetchAllProviders = () => {
    getProviders({ $forSpouse: forSpouse }).then((response: any) => {
      setAddDoctorState({
        ...addDoctorState,
        AddedDoctor: response.data.data,
      })
    })
  }

  const fetchCityDetails = () => {
    setLoadingCityDetails(true)
    getCityDetails({
      $zipcode: customerStore.postalCode,
      $radius: 100,
      $size: 6,
    })
      .then((response: any) => {
        setCityDetails(response.data.data)
        setLoadingCityDetails(false)
      })
      .catch((err) => {
        setLoadingCityDetails(false)
        snackbarStore.set({
          snackbarMessage: 'Could not fetch neighbouring cities',
          snackbarOpen: true,
          snackbarType: SnackbarTypes.ERROR,
        })
      })
  }

  const handleCancel = () => {
    setIsEditProvider(false)
    setAddDoctorState({
      ...addDoctorState,
      Doctor: [],
      addingDoctors: false,
    })
  }

  const handleEditProviders = (data: any) => {
    setEditProviderLoading(true)
    updateProviderAddress(
      addDoctorState.Doctor[0].id,
      data.npi,
      data.id,
      forSpouse
    )
      .then((response: any) => {
        mPartDPlansFilterStore.clearStore()
        medicareAdvantageFilterQuoteStore.clearStore()
        snackbarStore.set({
          snackbarMessage: StringConstants.SNACKBAR_SAVE_SUCCESS_MSG,
          snackbarOpen: true,
          snackbarType: SnackbarTypes.SUCCESS,
        })
        let index = addDoctorState.AddedDoctor.findIndex(
          (x: any) => x.npi === data.npi
        )
        let addedDoctorsAfterUpdate = addDoctorState.AddedDoctor

        addedDoctorsAfterUpdate[index] = {
          ...addedDoctorsAfterUpdate[index],
          id: addDoctorState.Doctor[0].id,
          npi: data.npi,
          externalId: data.id,
          address1: data.address1,
          address2: data.address2,
        }
        setAddDoctorState({
          addingDoctors: false,
          Doctor: [],
          AddedDoctor: addedDoctorsAfterUpdate,
        })
        setIsEditProvider(false)
        setEditProviderLoading(false)
      })
      .catch((err: any) => {
        snackbarStore.set({
          snackbarMessage: getApiErrorMessage('update provider'),
          snackbarOpen: true,
          snackbarType: SnackbarTypes.ERROR,
        })
        setIsEditProvider(true)
        setEditProviderLoading(false)
      })
  }

  const handleEditDoctor = (item: any) => {
    setIsEditProvider(true)
    setAddDoctorState({
      ...addDoctorState,
      addingDoctors: true,
      Doctor: [{ ...item }],
    })
  }

  const handleDeleteDoctor = (item: any) => {
    setDeleteProviderLoading(true)
    deleteProvider(item.id, forSpouse)
      .then(() => {
        mPartDPlansFilterStore.clearStore()
        medicareAdvantageFilterQuoteStore.clearStore()
        snackbarStore.set({
          snackbarMessage: StringConstants.SNACKBAR_DELETE_SUCCESS_MSG,
          snackbarOpen: true,
          snackbarType: SnackbarTypes.SUCCESS,
        })
        setAddDoctorState((prev) => ({
          ...prev,
          AddedDoctor: prev.AddedDoctor.filter((d) => d.id !== item.id),
        }))
      })
      .catch(() => {})
      .finally(() => setDeleteProviderLoading(false))
  }

  return (
    <QuotesRefreshProvider>
      <Container>
        <SearchPromptWrapper>
          <h3>Add Your {isSpouse && "spouse/partner's"} Doctor</h3>
          <p>
            Adding your doctor can help us in determining if they are covered in
            a Medicare plan, and in suggesting plans that offer maximum
            physician coverage.
          </p>
          {!showProvidersSearchBar && (
            <Address>
              <div style={{ display: 'flex', flexDirection: 'row' }}>
                <h3>Where is your doctor located?</h3>
                <Tooltip
                  title={StringConstants.TOOLTIP_PHYSICIAN_LOCATION_MSG}
                  content={'i'}
                />
              </div>
              {/* <p>Search for a zip code:</p>
            <PostalCodeSelection
              onSubmit={(zipInfo: {
                code: string
                county?: County
                state?: string
                optCounties?: County[]
              }) => {
                if (zipInfo.code) {
                  setZipcodeInfo({ ...zipcodeInfo, ...zipInfo })
                  setShowProvidersSearchBar(!showProvidersSearchBar)
                }
              }}
            /> */}
              {!loadingCityDetails ? (
                <>
                  {cityDetails ? (
                    <NearCities
                      cities={cityDetails}
                      setSelectedCity={setSelectedCity}
                      setShowProvidersSearchBar={setShowProvidersSearchBar}
                    />
                  ) : (
                    <p style={{ fontWeight: '400' }}>
                      There are no neighbouring cities available
                    </p>
                  )}
                </>
              ) : (
                <BouncingDotsLoader padding='15px' />
              )}
            </Address>
          )}
          {showProvidersSearchBar && (
            <>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  marginTop: '20px',
                }}
              >
                <p>
                  Searching for doctors near
                  {!isEmpty(selectedCity) ? (
                    <h3>
                      {selectedCity.city}, {selectedCity.state}
                    </h3>
                  ) : (
                    <>
                      <span>
                        {' '}
                        zipcode <h3>{zipcodeInfo.code}</h3>
                      </span>
                    </>
                  )}
                </p>
                <p
                  style={{
                    textDecoration: 'underline',
                    marginLeft: '20px',
                    fontSize: '12px',
                    fontWeight: '600',
                    color: `${theme.colors.primary}`,
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    setShowProvidersSearchBar(!showProvidersSearchBar)
                    setSelectedCity({})
                    setZipcodeInfo({ code: '' })
                    setSearchDoctor(true)
                  }}
                >
                  Change
                </p>
              </div>
              {!addProviderLoading ? (
                <>
                  <SearchPrompt
                    addDoctorState={addDoctorState}
                    setAddDoctorState={setAddDoctorState}
                    handleNext={handleNext}
                    selectedCity={selectedCity}
                    fetchLookUpProviders={fetchLookUpProviders}
                    loadingFetch={loadingFetch}
                    providersLookUpData={providersLookUpData}
                    forSpouse={forSpouse}
                    setSearchDoctor={setSearchDoctor}
                    searchDoctor={searchDoctor}
                    setAddProviderLoading={setAddProviderLoading}
                    isInfoSteps={isInfoSteps}
                  />
                </>
              ) : (
                <BouncingDotsLoader padding='15px' />
              )}
            </>
          )}
        </SearchPromptWrapper>
        <AddedDoctorsWrapper>
          <AddedDoctorsHeader>
            <Icon childComponent={<GiHeartPlus />} fontSize='18px' />
            <span>Added Doctors: {addDoctorState.AddedDoctor.length}</span>
          </AddedDoctorsHeader>
          {addProviderLoading || deleteProviderLoading ? (
            <BouncingDotsLoader padding='15px' />
          ) : (
            <TableWrapper><EntryTable>
              <thead>
                <tr>
                  <Th>Name</Th>
                  <Th>Location</Th>
                  <Th></Th>
                </tr>
              </thead>
              <tbody>
                {addDoctorState.AddedDoctor.map((item, key) => (
                  <tr key={key}>
                    <Td>{item.name}</Td>
                    <Td>
                      {[item.address1, item.address2, item.city, `${item.state ?? ''} ${item.zip ?? ''}`.trim()]
                        .filter(Boolean)
                        .join(', ')}
                    </Td>
                    <ActionsTd>
                      <IconBtn
                        type='button'
                        onClick={() => handleEditDoctor(item)}
                        title='Edit'
                      >
                        <MdEdit size={15} />
                      </IconBtn>
                      <DeleteIconBtn
                        type='button'
                        onClick={() => setPendingDeleteDoctor(item)}
                        title='Delete'
                      >
                        <MdDeleteOutline size={15} />
                      </DeleteIconBtn>
                    </ActionsTd>
                  </tr>
                ))}
              </tbody>
            </EntryTable></TableWrapper>
          )}
        </AddedDoctorsWrapper>

        {isEditProvider && (
          <ModalComponent
            setOpen={() => setpopUpModal(false)}
            description='Popup - User Information Prompt'
            hideCloseButton={true}
            padding='0px 20px'
          >
            <ProviderCardComponent
              data={addDoctorState.Doctor[0]}
              handleCancel={handleCancel}
              handleEditProviders={handleEditProviders}
              editProviderLoading={editProviderLoading}
            />
          </ModalComponent>
        )}

        {pendingDeleteDoctor && (
          <ModalComponent
            setOpen={() => setPendingDeleteDoctor(null)}
            description='Popup - Delete Doctor Confirmation'
            hideCloseButton={true}
          >
            <DeleteConfirmationModal
              itemLabel='doctor'
              onConfirm={() => {
                handleDeleteDoctor(pendingDeleteDoctor)
                setPendingDeleteDoctor(null)
              }}
              onReject={() => setPendingDeleteDoctor(null)}
            />
          </ModalComponent>
        )}
      </Container>
    </QuotesRefreshProvider>
  )
}

export default withRouter(AddDoctor)
